document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".video-faq").forEach((section) => {

    const bubble = section.querySelector(".video-faq__bubble");
    const bubbleClose = section.querySelector(".video-faq__bubble-close");
    bubbleClose.addEventListener("click", (e) => {

  e.stopPropagation();

  stopAllVideos();

  section.style.display = "none";

});
    const popup = section.querySelector(".video-faq__popup");
    const close = section.querySelector(".video-faq__close");

    const video = section.querySelector(".video-faq__video");
    const bubbleVideo = section.querySelector(".video-faq__bubble-video");

function stopAllVideos() {

  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  if (bubbleVideo) {
    bubbleVideo.pause();
    bubbleVideo.currentTime = 0;
  }

}

    const playBtn = section.querySelector(".faq-play");
    const muteBtn = section.querySelector(".faq-mute");
    const progress = section.querySelector(".faq-progress");
    const speed = section.querySelector(".faq-speed");

    const questions = [...section.querySelectorAll(".video-faq__question")];
showRandomQuestions();
    /* -----------------------
   RANDOM QUESTIONS
----------------------- */

function shuffle(array) {

  const arr = [...array];

  for (let i = arr.length - 1; i > 0; i--) {

    const j = Math.floor(Math.random() * (i + 1));

    [arr[i], arr[j]] = [arr[j], arr[i]];

  }

  return arr;

}

function showRandomQuestions() {

  questions.forEach((button) => {

    button.style.display = "none";

  });

  const randomQuestions = shuffle(questions).slice(0, 3);

  randomQuestions.forEach((button) => {

    button.style.display = "block";

  });

}

    /* -----------------------
       OPEN / CLOSE
    ----------------------- */

    bubble.addEventListener("click", () => {

      section.classList.add("active");

      if(video){

        video.play().catch(()=>{});

      }

    });

    close.addEventListener("click", () => {

        section.classList.remove("active");

        stopAllVideos();

        });

    /* -----------------------
       PLAY / PAUSE
    ----------------------- */

    playBtn.addEventListener("click", () => {

      if(video.paused){

        video.play();

      }else{

        video.pause();

      }

    });

    video.addEventListener("play", ()=>{

      playBtn.innerHTML = "❚❚";

    });

    video.addEventListener("pause", ()=>{

      playBtn.innerHTML = "▶";

    });

    /* -----------------------
       MUTE
    ----------------------- */

    muteBtn.addEventListener("click",()=>{

      video.muted = !video.muted;

      muteBtn.innerHTML = video.muted ? "🔇" : "🔊";

    });

    /* -----------------------
       SPEED
    ----------------------- */

    speed.addEventListener("change",(e)=>{

      video.playbackRate = parseFloat(e.target.value);

    });

    /* -----------------------
       PROGRESS
    ----------------------- */

    video.addEventListener("timeupdate",()=>{

      if(!video.duration) return;

      progress.value =

      (video.currentTime/video.duration)*100;

    });

    progress.addEventListener("input",()=>{

      if(!video.duration) return;

      video.currentTime =

      (progress.value/100)*video.duration;

    });

    /* -----------------------
       QUESTION CLICK
    ----------------------- */

    questions.forEach((button) => {

  button.addEventListener("click", () => {

    const src = button.dataset.video;

    if (!src) return;

    const wasMuted = video.muted;
    const rate = video.playbackRate;

    video.pause();

    video.querySelectorAll("source").forEach((source) => {

      source.remove();

    });

    const source = document.createElement("source");

    source.src = src;

    source.type = "video/mp4";

    video.appendChild(source);

    video.load();

    video.muted = wasMuted;

    video.playbackRate = rate;

    video.play().catch(() => {});

    /* Show 3 new random questions */

    showRandomQuestions();

  });

});

  });

});

